import { Directive } from "@angular/core";

@Directive({
    selector: 'inner-content'
})
export class InnerContentDirective { }